import { SYNC_STATUS } from '../redux/sync/constants'
import { getCleanupSession } from './localReset/cleanupSession'
import { isCleanupActive } from './localReset/resetMarker'

/**
 * Regra única de "posso ativar a versão nova do app agora?".
 *
 * Só olha o estado do sync (`state.sync.currentSync`). Conexão NÃO entra: a versão nova só chega
 * a `waiting` depois de o precache dela terminar de baixar, então ativá-la e recarregar é servido
 * do próprio service worker, sem rede (diferente do `clearCache`, que apaga os caches).
 *
 * - SUCCESS (2) e ERROR (0): sync parado → libera.
 * - SYNCING (1), DOWNLOADING_FARM (3), PROCESSING (4), RETRYING (5): sync em andamento → bloqueia.
 * - qualquer outra coisa (undefined, NaN, valor novo): bloqueia (conservador).
 * - limpeza de dados locais em andamento (PG-060): bloqueia, independentemente do sync.
 */

export const SYNC_BUSY_MESSAGE =
  'Aguarde o fim da sincronização para atualizar.'

export type UpdateGateReason =
  'sync_busy' | 'unknown_status' | 'cleanup_in_progress'

export interface UpdateGate {
  allowed: boolean
  reason: UpdateGateReason | null
  message: string | null
}

const IDLE_STATUSES: number[] = [SYNC_STATUS.SUCCESS, SYNC_STATUS.ERROR]
const BUSY_STATUSES: number[] = [
  SYNC_STATUS.SYNCING,
  SYNC_STATUS.DOWNLOADING_FARM,
  SYNC_STATUS.PROCESSING,
  SYNC_STATUS.RETRYING,
]

export function evaluateUpdateGate(syncStatus: unknown): UpdateGate {
  // Limpeza de dados em andamento (sessão em memória ou marcador de retomada): não recarregar.
  if (getCleanupSession() !== null || isCleanupActive()) {
    return {
      allowed: false,
      reason: 'cleanup_in_progress',
      message: 'Aguarde o fim da limpeza dos dados para atualizar.',
    }
  }
  if (typeof syncStatus === 'number' && IDLE_STATUSES.includes(syncStatus)) {
    return { allowed: true, reason: null, message: null }
  }
  if (typeof syncStatus === 'number' && BUSY_STATUSES.includes(syncStatus)) {
    return { allowed: false, reason: 'sync_busy', message: SYNC_BUSY_MESSAGE }
  }
  return {
    allowed: false,
    reason: 'unknown_status',
    message: SYNC_BUSY_MESSAGE,
  }
}
